export const pageRoutes = {

    // ROOT
    root: '/',

    // AUTH
    auth: {
        login: '/login',
        resetPassword: '/reset-password',
        forgotPassword: '/forgot-password'
    },

    // LEGAL
    legal: {
        privacyPolicy: '/privacy-policy',
        termsOfService: '/terms-of-service'
    },

    // ACCOUNT
    account: {
        root: '/account'
    },

    // DASHBOARD
    dashboard: {
        root: '/dashboard1',
        noTeams: '/dashboard1/no-teams',
        team: {
            root: (teamId: string | number) => `/dashboard1/team/${teamId}`,
            player: {
                root: (teamId: string | number, playerId: string | number, isInit?: boolean) => `/dashboard1/team/${teamId}/player/${playerId}${isInit ? '?init=1' : ''}`,
                session: {
                    root: (teamId: string | number, playerId: string | number, sessionId: string | number, isInit?: boolean) => `/dashboard1/team/${teamId}/player/${playerId}/session/${sessionId}${isInit ? '?init=1' : ''}`,
                    details: (teamId: string | number, playerId: string | number, sessionId: string | number, searchParams?: URLSearchParams) => `/dashboard1/team/${teamId}/player/${playerId}/session/${sessionId}/details${searchParams ? `?${searchParams.toString()}` : ''}`,
                }
            }
        }
    },

    // UPLOAD
    upload: {
        root: '/upload'
    },

    // TEAMS
    team: {
        list: '/team/list',
        create: '/team/create',
        view: (teamId: string | number) => `/team/${teamId}`,
    },

    // SESSIONS
    session: {
        list: '/session/list',
        access: {
            root: '/session/access',
            players: (teamId: string | number) => `/session/access/team/${teamId}/player`,
            sessions: (teamId: string | number, playerId: string | number) =>
                `/session/access/team/${teamId}/player/${playerId}/session`,
        },
    },

    // USERS
    users: {
        list: '/users/list',
        view: (userId: string | number) => `/users/${userId}`
    },

    // CATAPULT
    catapult: {
        root: '/catapult'
    },

    // STATSPORT
    statsport: {
        root: '/statsport'
    },

    // ADMIN
    admin: {

        root: '/admin',

        // USERS
        // users: {
        //     root: '/admin/users',
        //     view: (userId: string | number) => `/admin/users/${userId}`
        // },

        // CLIENTS
        clients: {
            root: '/admin/clients',
            list: '/admin/clients/list',
            view: {
                root: (clientId: string | number) => `/admin/clients/${clientId}`,
                user: (clientId: string | number, userId: string | number) => `/admin/clients/${clientId}/users/${userId}`,
            }
        }
    }
}
